var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.354 27.4593C45.354 28.4143 44.5557 29.1957 43.5799 29.1957H2.77416C1.79837 29.1957 1 28.4143 1 27.4593V3.14947C1 2.19444 1.79837 1.41306 2.77416 1.41306H43.5799C44.5557 1.41306 45.354 2.19444 45.354 3.14947V27.4593Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.467 4.01768H7.20957C4.26978 4.01768 1.88708 6.34968 1.88708 9.22692V28.9283C2.15143 29.0828 2.44417 29.1957 2.77417 29.1957H43.5799C44.5557 29.1957 45.354 28.4143 45.354 27.4593V4.28509C45.0897 4.13054 44.7969 4.01768 44.467 4.01768Z",
    fill: "#FCB701"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.467 4.01768H42.8897C41.9068 16.6292 30.3624 26.591 16.2276 26.591C10.946 26.591 6.03507 25.1811 1.88708 22.7831V28.9283C2.15143 29.0828 2.44417 29.1957 2.77417 29.1957H43.5799C44.5557 29.1957 45.354 28.4143 45.354 27.4593V4.28509C45.0897 4.13054 44.7969 4.01768 44.467 4.01768Z",
    fill: "#FCB701"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7416 4.88589H6.32251V8.35871H18.7416V4.88589Z",
    fill: "#00DCF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.645 11.8315H6.32251V17.0408H11.645V11.8315Z",
    fill: "#FCB701"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4354 1.41306H2.77416C1.79837 1.41306 1 2.19444 1 3.14947V27.4593C1 28.4143 1.79837 29.1957 2.77416 29.1957H43.5799C44.5557 29.1957 45.354 28.4143 45.354 27.4593V3.14947C45.354 2.19444 44.5557 1.41306 43.5799 1.41306H9.87081",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7416 4.88589H6.32251V8.35871H18.7416V4.88589Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.645 11.8315H6.32251V17.0408H11.645V11.8315Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9348 20.5136H38.2573",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.064 20.5136H29.3864",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1934 20.5136H20.5158",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32251 20.5136H11.645",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7416 25.7228H31.1607",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32251 25.7228H15.1933",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4354 1.41306H2.77416C1.79837 1.41306 1 2.19444 1 3.14947V27.4593C1 28.4143 1.79837 29.1957 2.77416 29.1957H43.5799C44.5557 29.1957 45.354 28.4143 45.354 27.4593V3.14947C45.354 2.19444 44.5557 1.41306 43.5799 1.41306H9.87081",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7416 4.88589H6.32251V8.35871H18.7416V4.88589Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.645 11.8315H6.32251V17.0408H11.645V11.8315Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9348 20.5136H38.2573",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.064 20.5136H29.3864",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1934 20.5136H20.5158",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32251 20.5136H11.645",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7416 25.7228H31.1607",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32251 25.7228H15.1933",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardColor);
export default __webpack_public_path__ + "static/media/credit-card-color.0ee7c285ce0fd3f2c38a640d819f26a4.svg";
export { ForwardRef as ReactComponent };